import AutoDismissToolTip from "@/components/AutoDismissToolTip";
import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";

interface OriginalIdFieldProps {
    shop?: ShopDTO;
}

const OriginalIdField: React.FC<OriginalIdFieldProps> = (props) => {
    const { shop } = props;
    return (
        <AutoDismissToolTip
            placement="top"
            title={
                <p>
                    1、订单号最多可同时搜索200个
                    <br />
                    2、多个订单编号间可用逗号、换行、空格分隔
                </p>
            }
            trigger="click"
        >
            <Form.Item
                label={
                    <span className="search-field-label">
                        {[ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shop?.type)
                            ? "代发编号"
                            : "订单编号"}
                    </span>
                }
                name="originalIds"
            >
                <Input allowClear />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(OriginalIdField);
